import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from "moment"
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import {observer} from "mobx-react"
import CalendarStore from "./CalendarStore"
import MomentUtils from '@date-io/moment';
import 'moment/locale/fr';

import { DateTimePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

@observer
class ValidateDay extends React.Component {
  constructor(props) {
    super(props);
    this.validate         = this.validate.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.state= {
      currentDate: moment()
    }
  }
  validate(e){
    e.preventDefault()
    axios.post("/api/v1/experts/rdv/validateDate",{duree: CalendarStore.duration, date: CalendarStore.currentSelectMoment,demande: this.props.demande.id}).then((data)=>{
      location.reload();
    })
  }
  handleDateChange(date){
    console.log(date)
    if(date.isValid()){
    this.setState({
      currentDate: date
    })
    CalendarStore.select(date.format("YYYY-MM-DDTH:m:00.000+02:00"),date.format("DD-MM-YYYY H:m"),date.format("DD/MM/YYYY"))
    }
  }
  render () {
      return (
        <React.Fragment>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"fr"}>
          <div className="container">
          <h2> </h2>
            <div className="row">
              <div className="col s6">
                <h2 className="center">Aucune de ces dates vous va?</h2>
                <div className="input-field">
                    <KeyboardDateTimePicker
                    variant="inline"
                    ampm={false}
                    label="Entrez une date manuellement"
                    value={this.state.currentDate}
                    onChange={this.handleDateChange}
                    onError={console.log}
                    format="DD/MM/YYYY HH:mm"
                    />
               </div>
              </div>
              <div className="col s6">
              {CalendarStore.currentSelect=="" ? (
                <div></div>
              ) : (
               <a href="" onClick={this.validate} className="btn btn-large">Valider le {CalendarStore.currentSelect}</a>
              )}
              </div>
            </div>
          </div>
          </MuiPickersUtilsProvider>
        </React.Fragment>
      );
  }
}

export default ValidateDay
